export const UrlSearchParams = {
  Tab: "tab",
  userRole: "userRole",
  contentKey: "contentKey",
  name: "name",
};
